import { createFileRoute } from '@tanstack/react-router'

import EditPoktanPage from '@/components/pages/backoffice/_klb-petani/_poktan/_$poktanId/edit/containers/EditPoktanPage'

export const Route = createFileRoute(
  '/_backoffice/klb-petani/poktan/$poktanId/edit'
)({
  component: EditPoktanPage
})
